import React from 'react'
import { Typography, Icon, Row, Col, Spin } from 'antd'
import { Queries } from '../../../graphql'
import { withApollo } from 'react-apollo'
import Container from '../../../components/user/Container'
import pdfMock from '../../../assets/images/orientation/orientation.pdf'
//////////////////////addmodalINTERNAL_SERVER_ERROR
import ModalErrors from '../../../components/user/ModalErrors'
import { youtubeParser } from '../../../utils/youtube'


const { Text, Title } = Typography

class CourseDetail extends React.Component {

    state = {
		detailPolicy : [],
        visibleModal: false,
        urlTest : 'https://www.youtube.com/watch?v=Aiay8I5IPB8',
	}

	fetchListPost = async() =>{
		const { client, location, match } = this.props
        const { selectMonth, selectYear } = this.state
        
		const { data ,errors} = await client.query({
            query: Queries.fetchListPost,
            variables: {
                postId: match.url.split('/')[2]
			}
        })
        //////////////////////addmodalINTERNAL_SERVER_ERROR
        if (errors && errors[0].extensions.code === 'INTERNAL_SERVER_ERROR') {
            await this.setState({
                showModalErrors: true
            })
        }

        await this.setState({
            detailPolicy: data.fetchListPost.data[0],
		})
    }
    
    async componentDidMount(){
		await this.fetchListPost()
	}

    render() {
        const { match } = this.props
        const { detailPolicy } = this.state
        console.log('detailPolicy',detailPolicy)
        // .split('https://www.youtube.com/watch?v=')[1]
        return (
            <Container match={match}>
                {/* //////////////////////addmodalINTERNAL_SERVER_ERROR */}
                {
                    this.state.showModalErrors &&
                    <ModalErrors />
                }
                {/* //////////////////////addmodalINTERNAL_SERVER_ERROR */}
                <Row>
                    {
                        detailPolicy.length !== 0 &&
                            <>
                                <Col>
                                    <Title level={4} className="mr-2 pr-1 mb-1">
                                        {detailPolicy.postTitleTH}
                                    </Title>
                                    <div dangerouslySetInnerHTML={{ __html: detailPolicy.descriptionTH}}/>
                                </Col>
                                <Col>
                                    <iframe src={"https://www.youtube.com/embed/"+youtubeParser(detailPolicy.linkOriginal)} style={{ width: '100%', height: '400px' }}></iframe>
                                </Col>
                            </>
                        ||
                        <Col align="center" className="mt-5">
                            <Spin size="large" />
                        </Col>
                    }
                </Row>
            </Container>
        )
    }
}

CourseDetail.propTypes = {
    //
}

export default withApollo(CourseDetail)